import React, { useState } from 'react';
import ButtonOptions from '../../../../../../components/NovoSistema/ButtonOptions';
import ButtonsGeneric from '../../../../../../components/NovoSistema/ButtonsGeneric';
import { ContainerSection } from '../../../../../../components/NovoSistema/ContainerSection';
import HeaderButtons from '../../../../../../components/NovoSistema/HeaderButtons';
import InputDate from '../../../../../../components/NovoSistema/InputDate';
import InputText from '../../../../../../components/NovoSistema/InputText';
import { WrapperInputsNewSystem } from '../../../../../../components/NovoSistema/WrapperInputsNewSystem';
import { WrapperLegendItens } from '../../../../../../components/NovoSistema/WrapperLegendItens';
import Legends from '../../../../../../components/NovoSistema/Legends';

export default function CotacaoDeCompraAdd({ setOption }) {
  const [internalOption, setInternalOption] = useState('principal');
  return (
    <div>
      <ContainerSection>
        <h3>Principal</h3>
        <div>
          <WrapperInputsNewSystem>
            <InputText title="Número" id="Numero" widthPercentage="20%" />
            <InputDate title="Data" id="Data" widthPercentage="20%" />
            <InputDate title="*Data Limite" id="DataLimite" widthPercentage="20%" />
            <InputText title="Situação" id="Situacao" widthPercentage="20%" />
          </WrapperInputsNewSystem>
          <WrapperInputsNewSystem>
            <InputText title="Envio" id="Envio" widthPercentage="30%" />
            <InputText title="Conclusão" id="Conclusao" widthPercentage="30%" />
            <InputText title="Solicitante" id="Solicitante" widthPercentage="30%" />
          </WrapperInputsNewSystem>
        </div>
      </ContainerSection>
      <HeaderButtons>
        <ButtonOptions
          buttonName="Principal"
          border="#333F50"
          active={internalOption === 'principal' ? true : false}
          yourFunction={() => setInternalOption('principal')}
        />
        <ButtonOptions buttonName="Parceiro de Negócios" border="#333F50" disabled={true} />
        <ButtonOptions
          buttonName="Observações"
          border="#333F50"
          active={internalOption === 'observation' ? true : false}
          yourFunction={() => setInternalOption('observation')}
        />
        <ButtonOptions
          buttonName="Retorno"
          border="#333F50"
          active={internalOption === 'return' ? true : false}
          yourFunction={() => setInternalOption('return')}
        />
      </HeaderButtons>
      {internalOption === 'principal' && (
        <ContainerSection>
          <h3>itens</h3>
          <div>
            <WrapperInputsNewSystem>
              <InputText title="*Produto" id="Produto" widthPercentage="30%" />
              <InputText title="*Unidade" id="Unidade" widthPercentage="30%" />
              <InputText title="*Quantidade" id="Quantidade" widthPercentage="30%" />
            </WrapperInputsNewSystem>
            <ButtonsGeneric>
              <button className="success">+ Adicionar</button>
            </ButtonsGeneric>
            <ContainerSection>
              <h3>Legenda</h3>
              <Legends
                itens={[
                  { text: 'Cadastrado', color: 'blue' },
                  { text: 'Importado Parcial', color: 'lightBlue' },
                  { text: 'Finalizado', color: 'gray' },
                ]}
              />
            </ContainerSection>
          </div>
        </ContainerSection>
      )}
      {internalOption === 'observation' && (
        <div>
          <ContainerSection>
            <h3>Observações</h3>
            <div>
              <textarea name="Observation" id="observation" cols="100" rows="3"></textarea>
              <p>Máximo de 500 caracteres.</p>
            </div>
          </ContainerSection>
          <ContainerSection>
            <h3>Anexos</h3>
            <WrapperLegendItens>
              <input type="file" name="attachments" id="attachments" />
            </WrapperLegendItens>
          </ContainerSection>
        </div>
      )}
      <ButtonsGeneric>
        <button className="success">Confirmar</button>
        <button className="error" onClick={() => setOption('search')}>
          Retornar
        </button>
      </ButtonsGeneric>
      <span> {' * '} Campo de preenchimento Obrigatório</span>
    </div>
  );
}
